module.exports = __webpack_public_path__ + "img/dirty_labatory_seat.c401c295.svg";